import { Form, Formik } from "formik";
import { useHistory } from "react-router-dom";
import validations from "../../../services/validations";
import EditProfileFields from "../../formsFields/EditProfileFields";
import useProfile from "../../../services/utils/custom hooks/useProfile";
import { useEffect, useState } from "react";
import { useUpdateProfileMutation } from "../../../services/utils/custom hooks/useUpdateProfile";
import AdminContentLayout from "../../../layouts/AdminContentLayout";

function ProfileForm(): JSX.Element {
  const { mutation, updating } = useUpdateProfileMutation();
  const [profileValues, setProfileValues] = useState<any>({
    firstName: "",
    lastName: "",
    email: "",
    role: "",
    profileImage: "",
  });
  const { data: profile, isLoading } = useProfile();
  const roles = profile?.user?.roles ?? [];
  const history = useHistory();

  useEffect(() => {
    if (!isLoading && !!profile) {
      const profileValues: any = {
        firstName: profile?.user?.firstName || "",
        lastName: profile?.user?.lastName || "",
        email: profile?.user?.email || "",
        role: profile?.roles?.join(", ") || "",
        profileImage:
          profile?.user?.imageUrl || profile?.user?.profileImage || "", // Handle both
      };

      if (roles.includes("Physician")) {
        profileValues.npi = profile.user.npi || "";
        profileValues.suffix = profile.user.suffix || "";
        profileValues.specialty = profile.user.specialty || "";
      }

      setProfileValues(profileValues);
    }
  }, [isLoading, profile]);

  const handleSubmit = (values: any) => {
    const payload = {
      ...values,
      profileImage: values.profileImage,
    };

    const mutationPromise = mutation.mutateAsync(payload);

    Promise.all([mutationPromise])
      .then(() => {
        history.push("/access/profile");
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  };

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <Formik
      initialValues={profileValues}
      validationSchema={validations.profileFormValidation}
      enableReinitialize
      onSubmit={handleSubmit}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        getFieldMeta,
        submitForm,
        isValid,
      }) => {
        const buttons: any = [
          {
            buttonTheme: "secondary",
            textInformation: {
              text: "CANCEL",
              fontWeight: "font-bold",
            },
            className: "md:mx-5",
            onClick: () => {
              history.push("/access/profile");
            },
          },
          {
            buttonTheme: "primary",
            disabled: !isValid || updating,
            textInformation: {
              text: "Save",
              fontWeight: "font-bold",
            },
            className: "mx-5",
            onClick: () => {
              submitForm();
            },
            loading: updating,
          },
        ];
        return (
          <AdminContentLayout
            pageTitle="Profile | CSTL"
            subHeaderTitle="My Profile"
            showButtonInSubheaderForMobile
            hideSubHeaderSelectors
            customButtons={buttons}
          >
            <Form className="xs:px-4 md:px-4 md:w-[28%] mt-4">
              <EditProfileFields
                values={values}
                touched={touched}
                showPhysicianFields={roles.includes("Physician")}
                errors={errors}
                handleChange={handleChange}
                handleBlur={handleBlur}
                getFieldMeta={getFieldMeta}
              />
              {/* <div className="mt-5 flex md:hidden">
                {buttons?.map((button: any, index: number) => (
                  <Button
                    key={button.textInformation.text + index}
                    {...button}
                  />
                ))}
              </div> */}
            </Form>
          </AdminContentLayout>
        );
      }}
    </Formik>
  );
}

export default ProfileForm;
